import React from 'react';
import SpaSearchVariant from './SpaSearchVariant';
import SpaSearchControl from './SpaSearchControl';

const SpaSearch = props => {
  const { isVariant } = props;

  return isVariant ? (
    <SpaSearchVariant {...props} />
  ) : (
    <SpaSearchControl {...props} />
  );
};

export default SpaSearch;
